/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ProductRegisterResVo } from './ProductRegisterResVo';
import {
    ProductRegisterResVoFromJSON,
    ProductRegisterResVoFromJSONTyped,
    ProductRegisterResVoToJSON,
    ProductRegisterResVoToJSONTyped,
} from './ProductRegisterResVo';

/**
 * 
 * @export
 * @interface ResponseListProductRegisterResVo
 */
export interface ResponseListProductRegisterResVo {
    /**
     * 接口状态码
     * @type {number}
     * @memberof ResponseListProductRegisterResVo
     */
    code?: number;
    /**
     * 接口返回消息
     * @type {string}
     * @memberof ResponseListProductRegisterResVo
     */
    message?: string;
    /**
     * 
     * @type {Array<ProductRegisterResVo>}
     * @memberof ResponseListProductRegisterResVo
     */
    data?: Array<ProductRegisterResVo>;
}

/**
 * Check if a given object implements the ResponseListProductRegisterResVo interface.
 */
export function instanceOfResponseListProductRegisterResVo(value: object): value is ResponseListProductRegisterResVo {
    return true;
}

export function ResponseListProductRegisterResVoFromJSON(json: any): ResponseListProductRegisterResVo {
    return ResponseListProductRegisterResVoFromJSONTyped(json, false);
}

export function ResponseListProductRegisterResVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponseListProductRegisterResVo {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'message': json['message'] == null ? undefined : json['message'],
        'data': json['data'] == null ? undefined : ((json['data'] as Array<any>).map(ProductRegisterResVoFromJSON)),
    };
}

export function ResponseListProductRegisterResVoToJSON(json: any): ResponseListProductRegisterResVo {
    return ResponseListProductRegisterResVoToJSONTyped(json, false);
}

export function ResponseListProductRegisterResVoToJSONTyped(value?: ResponseListProductRegisterResVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'message': value['message'],
        'data': value['data'] == null ? undefined : ((value['data'] as Array<any>).map(ProductRegisterResVoToJSON)),
    };
}

